import CheckIcon from '@mui/icons-material/Check';
import { Box, Typography, Button } from '@mui/material';
import copy from 'copy-to-clipboard';
import React from 'react';
import { useTranslation } from 'react-i18next';

import DialogCustom from 'commons/DialogCustom';
import Text from 'commons/Text';
import { ReactComponent as CopyIcon } from 'images/copy_icon.svg';
import { ToastTopHelper } from 'utils/utils';

import useStyles from './styles';

const ShareLinkResultDialog = ({ open, onClose, createdLink }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleCopyLink = () => {
    copy(createdLink);
    ToastTopHelper.success(t('link_copied') || 'Link copied to clipboard');
  };

  return (
    <DialogCustom
      isShowDialog={open}
      onCancel={onClose}
      onSubmit={onClose}
      dialogTitle={t('share_link_created')}
      textSubmit={t('done') || 'Done'}
      textCancel={t('close') || 'Close'}
      maxWidth="md"
    >
      <Box className={classes.container}>
        {/* Success Message */}
        <Box className={classes.successSection}>
          <CheckIcon className={classes.successIcon} />
          <Text className={classes.successTitle}>{t('share_link_created_successfully')}</Text>
        </Box>

        {/* Link Information */}
        <Box className={classes.section}>
          <Text className={classes.sectionTitle}>{t('share_link')}</Text>

          <Box className={classes.linkContainer}>
            <Typography className={classes.linkText}>{createdLink}</Typography>
            <Button
              onClick={handleCopyLink}
              startIcon={<CopyIcon />}
              variant="outlined"
              size="small"
              className={classes.copyButton}
            >
              {t('copy_link')}
            </Button>
          </Box>
        </Box>
      </Box>
    </DialogCustom>
  );
};

export default ShareLinkResultDialog;
